var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.0155 8.17236C3.0155 7.91923 3.20361 7.71004 3.44766 7.67693L3.5155 7.67236L13.5155 7.67236C13.7916 7.67236 14.0155 7.89622 14.0155 8.17236C14.0155 8.42549 13.8274 8.63469 13.5834 8.6678L13.5155 8.67236H3.5155C3.23936 8.67236 3.0155 8.44851 3.0155 8.17236Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12951 4.51061C8.93383 4.31577 8.93314 3.99919 9.12799 3.80351C9.30511 3.62561 9.58285 3.60888 9.77891 3.75369L9.83509 3.80198L13.8684 7.81798C14.0468 7.99564 14.0631 8.27438 13.9171 8.47043L13.8685 8.52658L9.83512 12.5432C9.63945 12.7381 9.32287 12.7375 9.12802 12.5418C8.95087 12.3639 8.93531 12.0861 9.08095 11.8907L9.12948 11.8347L12.8068 8.1721L9.12951 4.51061Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight1);
export default __webpack_public_path__ + "static/media/ArrowRight1.85c182d6.svg";
export { ForwardRef as ReactComponent };